export const tourPositionsPaginationConfig = () => ({
  keyArgs: false,
});
